<div class="header p-2 bg-primary text-white">{{ label }}</div>
